import { render, staticRenderFns } from "./easyFooter.vue?vue&type=template&id=6d2ca7ce&scoped=true&"
import script from "./easyFooter.vue?vue&type=script&lang=js&"
export * from "./easyFooter.vue?vue&type=script&lang=js&"
import style0 from "./easyFooter.vue?vue&type=style&index=0&id=6d2ca7ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ca7ce",
  null
  
)

export default component.exports